import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    currentRoute: '',
    currentRootRoute: {},
    recruitScrollY:0,
    url:'https://www.wlyuan.com.cn'
};

const mutations = {
    currentRoute(state, current) {
        state.currentRooute = current;
    },
    currentRootRoute(state, current) {
        state.currentRootRoute = current;
    }
};

const getters = {

};

const store = new Vuex.Store({
    state,
    mutations,
    getters
});

export default store


// WEBPACK FOOTER //
// ./src/store/index.js